/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.similey-rating {
  width: 100%;

  & button {
    @include mixins.use-available-space;
    height: 40px;
  }

  .smiley-rating-positive {
    &.Mui-selected {
      background-color: variables.$rating-minor-color;

      &:hover {
        background-color: variables.$rating-minor-color-hover;
      }
    }
  }
  .smiley-rating-neutral {
    &.Mui-selected {
      background-color: variables.$rating-medium-color;
      color: variables.$color-black;

      &:hover {
        background-color: variables.$rating-medium-color-hover;
      }
    }
  }

  .smiley-rating-negative {
    &.Mui-selected {
      background-color: variables.$rating-major-color;

      &:hover {
        background-color: variables.$rating-major-color-hover;
      }
    }
  }
}
